<template>
  <div id="user-edit-tab-info">
    <div v-if="mounted">
      <validation-observer
        ref="main_form"
        v-slot="{ validated }"
      >
        <b-row>
          <b-col cols="12">
            <!-- GENERAL -->
            <div class="offer-info-block">
              <div style="padding: 1.143rem 1.714rem">
                <b-media no-body>
                  <b-media-aside class="mr-1">
                    <b-avatar
                      size="40"
                      variant="light-primary"
                    >
                      <feather-icon
                        size="20"
                        icon="BookIcon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <div class="offer-info-block-title">
                      {{ $t('apps.general') }}
                    </div>
                  </b-media-body>
                </b-media>
              </div>
              <hr style="margin: 0;">
              <div style="padding: 1.714rem;">
                <b-row>
                  <b-col cols="9">
                    <b-row style="padding-bottom: 0.857rem;">
                      <b-col cols="12">
                        <label>{{ $t('apps.currencyName') }}</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="6"
                        style="padding-right: 2.286rem; border-right: 0.143rem solid #ddd;"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          :name="$t('apps.currencyName')"
                          vid="currency name"
                          :rules="{ required: true }"
                        >
                          <b-input
                            v-model="currency_name"
                            name="currency_name"
                          />
                          <small
                            v-if="validated && errors.length > 0"
                            class="text-danger d-block"
                          >{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col
                        cols="6"
                        style="padding-left: 2.286rem;"
                      >
                        <div class="currency-description">
                          {{ $t('apps.nameOfYourInAppCurrencyInPluralForm') }}<br>{{ $t('apps.exampleDiamondsCoinsCredits') }}
                        </div>
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 2.857rem; padding-bottom: 0.857rem;">
                      <b-col cols="12">
                        <label>{{ $t('apps.currencyExchangeRate') }}</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="6"
                        style="padding-right: 2.286rem; border-right: 0.143rem solid #ddd;"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          :name="$t('apps.currencyExchangeRate')"
                          vid="currency exchange rate"
                          :rules="{ required: true, min_value: 10 }"
                        >
                          <b-input
                            v-model="currency_exchange_rate"
                            type="number"
                            name="currency_exchange_rate"
                          />
                          <small
                            v-if="validated && errors.length > 0"
                            class="text-danger d-block"
                          >{{ errors[0] }}</small>
                          <small
                            v-if="currency_exchange_rate && currency_name"
                            class="text-secondary"
                          >{{ $t('apps.userRewardPerDollar', { value1: currency_exchange_rate, value2: currency_name }) }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col
                        cols="6"
                        style="padding-left: 2.286rem;"
                      >
                        <div class="currency-description">
                          {{ $t('apps.equivalentOf1InYourInAppCurrency') }}<br>{{ $t('apps.example100ForEvery1YouEarnWithUs') }}<br>
                        </div>
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 2.857rem; padding-bottom: 0.857rem;">
                      <b-col cols="12">
                        <label>{{ $t('apps.currencyExchangeRateScreenoutRewards') }}</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="6"
                        style="padding-right: 2.286rem; border-right: 0.143rem solid #ddd;"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          :name="$t('apps.currencyExchangeRateScreenoutRewards')"
                          vid="currency exchange rate (Screenout Rewards)"
                          :rules="{ required: true, min_value: 10 }"
                        >
                          <b-input
                            v-model="currency_exchange_rate_screenouts"
                            type="number"
                            name="currency_exchange_rate_screenouts "
                          />
                          <small
                            v-if="validated && errors.length > 0"
                            class="text-danger d-block"
                          >{{ errors[0] }}</small>
                          <small
                            v-if="currency_exchange_rate_screenouts && currency_name"
                            class="text-secondary"
                          >
                            {{ $t('apps.userRewardPerDollar', { value1: currency_exchange_rate_screenouts, value2: currency_name }) }}
                          </small>
                        </validation-provider>
                      </b-col>
                      <b-col
                        cols="6"
                        style="padding-left: 2.286rem;"
                      >
                        <div class="currency-description">
                          {{ $t('apps.equivalentOf1InYourInAppCurrency') }}<br>
                          {{ $t('apps.onlyAppliesToScreenoutRewards') }}<br>
                          {{ $t('apps.example100ForEvery1YouEarnWithUs') }}
                        </div>
                      </b-col>
                    </b-row>

                    <!-- Games/Offers exchange rate -->
                    <b-row style="margin-top: 2.857rem; padding-bottom: 0.857rem;">
                      <b-col cols="12">
                        <label>{{ $t('apps.currencyExchangeRateGamesOffers') }}</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="6"
                        style="padding-right: 2.286rem; border-right: 0.143rem solid #ddd;"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          :name="$t('apps.currencyExchangeRateGamesOffers')"
                          vid="currency exchange rate (Games/Offers)"
                          :rules="{ required: false, min_value: 10 }"
                        >
                          <b-input
                            v-model="currency_exchange_rate_offers"
                            type="number"
                            name="currency_exchange_rate_offers"
                          />
                          <small
                            v-if="validated && errors.length > 0"
                            class="text-danger d-block"
                          >{{ errors[0] }}</small>
                          <small
                            v-if="currency_exchange_rate_offers && currency_name"
                            class="text-secondary"
                          >{{ $t('apps.userRewardPerDollar', { value1: currency_exchange_rate_offers, value2: currency_name }) }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col
                        cols="6"
                        style="padding-left: 2.286rem;"
                      >
                        <div class="currency-description">
                          {{ $t('apps.equivalentOf1InYourInAppCurrencyFor') }}<br>
                          {{ $t('apps.example100ForEvery1YouEarnWithUs') }}
                        </div>
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 2.857rem; padding-bottom: 0.857rem;">
                      <b-col cols="12">
                        <label>{{ $t('apps.rewardUnitsPerUsd') }}</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="6"
                        style="padding-right: 2.286rem; border-right: 0.143rem solid #ddd;"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          :name="$t('apps.rewardUnitsPerUsd')"
                          vid="reward units per usd"
                          :rules="{ units_per_usd_value: true }"
                        >
                          <b-input-group
                            prepend="1 USD ="
                          >
                            <b-input
                              v-model="units_per_usd"
                              type="number"
                              step="0.01"
                              min="0"
                              name="units_per_usd"
                            />
                          </b-input-group>
                          <small
                            v-if="validated && errors.length > 0"
                            class="text-danger d-block"
                          >{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col
                        cols="6"
                        style="padding-left: 2.286rem;"
                      >
                        <div class="currency-description">
                          {{ $t('apps.definesHowManyRewardUnitsInTheAppWeb') }}<br>
                          {{ $t('apps.exampleIf100Points1UsdEnter100') }}
                        </div>
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 2.857rem; padding-bottom: 0.857rem;">
                      <b-col cols="12">
                        <label>{{ $t('apps.moveDecimalPoint') }}</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="6"
                        style="padding-right: 2.286rem; border-right: 0.143rem solid #ddd;"
                      >
                        <b-radio-group
                          v-model="move_decimals"
                          style="margin-top: 0.429rem;"
                        >
                          <b-radio :value="null">
                            {{ $t('apps.no') }}
                          </b-radio>
                          <b-radio :value="1">
                            {{ $t('apps.1Decimal') }}
                          </b-radio>
                          <b-radio :value="2">
                            {{ $t('apps.2Decimal') }}
                          </b-radio>
                          <b-radio :value="3">
                            {{ $t('apps.3Decimal') }}
                          </b-radio>
                        </b-radio-group>
                      </b-col>
                      <b-col
                        cols="6"
                        style="padding-left: 2.286rem;"
                      >
                        <div class="currency-description">
                          {{ $t('apps.movesTheDecimalPointForYourCurrency') }}<br>
                          {{ $t('apps.example2ShowsReward120As120') }}<br>
                          {{ $t('apps.usefulIfYouRewardRealCurrencyToYourUsers') }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col
                    cols="3"
                  >
                    <div class="w-100 d-block block-attention font-weight-bold mt-4">
                      {{ $t('apps.forEach1YouGetYourUsersGet') }}
                    </div>
                    <div class="w-100 h-100 d-flex mt-2">
                      <iframe
                        ref="designMoveDecimalsIframe"
                        style="border: 1px solid #DBE1E6; box-sizing: border-box; border-radius: 4px;
                        overflow:hidden;"
                        frameborder="0"
                        :src="generalIframeUrlPreview"
                        width="190px"
                        height="116px"
                        scrolling="no"
                      />
                    </div>
                  </b-col>
                </b-row>

                <div class="block-attention">
                  <u>{{ $t('apps.attention') }}</u>
                  {{ $t('apps.theRewardAmountIsAlwaysRoundedToAFull') }} <br>{{ $t('apps.exchangeRateWillResultInRoundingInaccuracyTherefore10') }}
                </div>

              </div>
            </div>
          </b-col>

          <b-col>
            <div class="offer-info-block">
              <div style="padding: 1.143rem 1.714rem">
                <b-media no-body>
                  <b-media-aside class="mr-1">
                    <b-avatar
                      size="40"
                      variant="light-primary"
                    >
                      <feather-icon
                        size="20"
                        icon="ActivityIcon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <div class="offer-info-block-title">
                      {{ $t('apps.bonus') }}
                    </div>
                    <div class="offer-info-block-des">
                      {{ $t('apps.activateATemporaryBonusForAllYourUsersThe') }}
                    </div>
                  </b-media-body>
                </b-media>
              </div>
              <hr style="margin: 0;">
              <div
                style="padding: 1.714rem;"
              >
                <div class="row">
                  <div class="col-8 row d-flex justify-content-between align-items-start">
                    <div class="col-2">
                      <label>{{ $t('apps.bonusActive') }}</label>
                      <b-form-checkbox
                        v-model="bonus_active"
                        switch
                        class="mb-2"
                        :unchecked-value="0"
                        :value="1"
                      />
                    </div>
                    <div
                      v-if="bonus_active"
                      class="col-3"
                    >
                      <label>{{ $t('apps.bonusPercentage') }}</label>
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('apps.bonusPercentage')"
                        vid="bonus percentage"
                        :rules="{ required: true, max_value: 100 }"
                      >
                        <b-input-group append="%">
                          <b-input
                            v-model="user_bonus"
                            type="number"
                            name="user_bonus"
                          />
                        </b-input-group>

                        <small
                          v-if="validated && errors.length > 0"
                          class="text-danger"
                        >{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                    <div
                      v-if="bonus_active"
                      class="col-5"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('apps.bonusExpiry')"
                        vid="user_bonus_expires_at"
                        :rules="{ required: true }"
                      >
                        <label>{{ $t('apps.bonusExpiry') }}</label>
                        <localized-datepicker
                          v-model="user_bonus_expires_at"
                          :placeholder="$t('apps.selectDate')"
                        />
                        <small
                          v-if="validated && errors.length > 0"
                          class="text-danger"
                        >{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                    <div class="col-1" />
                  </div>
                  <div
                    class="col-4"
                  >
                    <!--                    <img-->
                    <!--                      src="@/assets/images/pages/bonus.webp"-->
                    <!--                      alt="Bonus Info"-->
                    <!--                      class="img-fluid"-->
                    <!--                    >-->
                    <iframe
                      ref="designBonusIframe"
                      style="border: 1px solid #DBE1E6; box-sizing: border-box; border-radius: 4px;
                        overflow:hidden;"
                      frameborder="0"
                      :src="computedBonusIframeUrlPreview"
                      scrolling="no"
                      :height="user_bonus !== null ? 250 : 155"
                      width="360"
                    />
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import LocalizedDatepicker from '@/main/custom-components/LocalizedDatepicker.vue'
import i18n from '@/libs/i18n'

import { extend, ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full'
// import InternalRoutingInput from './elements/InternalRoutingInput.vue'

extend('units_per_usd_value', {
  validate(value) {
    if (value === null || value === undefined || value === '') {
      return true
    }

    return /^\d{1,13}(\.\d{1,2})?$/.test(String(value))
  },
  message: (field, parameters) => i18n.t('apps.useANonNegativeNumberWithUpTo2', { ...parameters, _field_: field }),
})

export default {
  components: {
    LocalizedDatepicker,
    // InternalRoutingInput,
    ValidationProvider,
    ValidationObserver,
  },
  props: ['value', 'iFrameUrlQuery'],
  data() {
    return {
      currency_name: 'usd',
      currency_exchange_rate: null,
      currency_exchange_rate_screenouts: null,
      currency_exchange_rate_offers: null,
      units_per_usd: null,
      bonus_active: false,
      user_bonus: null,
      user_bonus_expires_at: null,
      mounted: false,
      move_decimals: null,
      generalIframeUrlPreview: '',
      bonusIframeUrlPreview: '',
    }
  },
  computed: {
    watchParentValue() {
      return [
        this.value.currency_name,
        this.value.currency_exchange_rate,
        this.value.currency_exchange_rate_screenouts,
        this.value.currency_exchange_rate_offers,
        this.value.units_per_usd,
        this.value.user_bonus,
        this.value.user_bonus_expires_at,
        this.value.move_decimals,
      ]
    },
    iframeBaseUrl() {
      const SURVEY_BASE_URL = process.env.VUE_APP_SURVEY_BASE_URL

      return `${SURVEY_BASE_URL}/design-preview`
    },
    timeLeftInSeconds() {
      if (!this.user_bonus_expires_at) return null

      const currentTimestamp = Math.floor(Date.now() / 1000) // Current timestamp in seconds
      const expirationTimestamp = Math.floor(new Date(this.user_bonus_expires_at).getTime() / 1000) // Convert selected date to timestamp in seconds

      // Calculate the difference (time left) in seconds
      const timeLeft = expirationTimestamp - currentTimestamp

      // If the time left is negative, it means the date is in the past
      return timeLeft > 0 ? timeLeft : 0
    },
    computedBonusIframeUrlPreview() {
      let src = `${this.bonusIframeUrlPreview}`

      // Conditionally add bonus_per if it's not null
      if (this.user_bonus !== null) {
        src += `&bonus_per=${this.user_bonus}&bonus_exp=${this.timeLeftInSeconds}`
      }

      return src
    },
  },
  watch: {
    $data: {
      handler() {
        if (this.mounted) {
          const appData = this.value
          appData.currency_name = this.currency_name
          appData.currency_exchange_rate = this.currency_exchange_rate
          appData.currency_exchange_rate_screenouts = this.currency_exchange_rate_screenouts
          appData.currency_exchange_rate_offers = this.currency_exchange_rate_offers
          appData.units_per_usd = this.units_per_usd
          appData.user_bonus = this.user_bonus
          appData.user_bonus_expires_at = this.user_bonus_expires_at
          appData.move_decimals = this.move_decimals
          this.$emit('input', appData)
        }
      },
      deep: true,
    },
    watchParentValue() {
      this.init_data()
    },
    bonus_active(value) {
      if (value === 0) {
        this.user_bonus = null
        this.user_bonus_expires_at = null
      }
    },
    iFrameUrlQuery: {
      immediate: true,
      deep: true,
      handler(newVal) {
        // Create a URLSearchParams object from the new query parameters
        const params = new URLSearchParams(newVal)

        // Define the params you want to filter out
        const paramsToRemove = ['app', 'cr_col', 'header', 'img', 'pol_url', 'show_filters', 'stats']

        // Iterate over params and remove those specified in paramsToRemove
        paramsToRemove.forEach(param => params.delete(param))

        // Construct the filtered URL
        this.generalIframeUrlPreview = `${this.iframeBaseUrl}/survey?${params.toString()}`
        this.bonusIframeUrlPreview = `${this.iframeBaseUrl}/bonus?${params.toString()}`
      },
    },
  },
  mounted() {
    this.init_data()
    this.mounted = true
    window.AppEditRewards = this
    this.bonus_active = this.value.user_bonus && this.value.user_bonus_expires_at ? 1 : 0
  },
  methods: {
    reset_data() {
      this.$emit('reset', [
        'currency_name',
        'currency_exchange_rate',
        'units_per_usd',
        'bonus_active',
        'user_bonus',
        'user_bonus_expires_at',
        'move_decimals',
      ])
    },
    init_data() {
      this.$data.currency_name = this.value.currency_name
      this.$data.currency_exchange_rate = this.value.currency_exchange_rate
      this.$data.currency_exchange_rate_screenouts = this.value.currency_exchange_rate_screenouts
      this.$data.currency_exchange_rate_offers = this.value.currency_exchange_rate_offers
      this.$data.units_per_usd = this.value.units_per_usd
      this.$data.user_bonus = this.value.user_bonus
      this.$data.user_bonus_expires_at = this.value.user_bonus_expires_at
      this.$data.move_decimals = this.value.move_decimals
    },
  },
}
</script>
<style scoped lang="scss">
.offer-info-block {
  background: #F8F8F8;
  border-radius: 0.429rem;
  margin-bottom: 0.857rem;

  label {
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 100%;
    color: #5E5873;
  }
}

.offer-info-block-title {
  font-weight: 600;
  font-size: 1.071rem;
  line-height: 1.286rem;
  color: #5E5873;
}

.currency-description {
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 140%;
  color: #6E6B7B;
}

.block-attention {
  margin-top: 1.143rem;
  padding: 1.143rem;
  background: rgba(255, 159, 67, 0.12);
  border-radius: 0.429rem;
  font-size: 1rem;
  line-height: 140%;

  u {
    font-weight: 600;
    color: #FF9F43;
  }
}
</style>
